
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { ClientFormData } from "@/types/client";

interface ServiceSectionProps {
  formData: ClientFormData;
  onFormDataChange: (newData: Partial<ClientFormData>) => void;
}

export const ServiceSection = ({ formData, onFormDataChange }: ServiceSectionProps) => {
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="meetingContext">Meeting Context</Label>
        <Textarea
          id="meetingContext"
          placeholder="How did you meet the client?"
          value={formData.meetingContext}
          onChange={(e) => onFormDataChange({ meetingContext: e.target.value })}
          required
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="serviceUsed">Service Used</Label>
        <Input
          id="serviceUsed"
          placeholder="What service did they use?"
          value={formData.serviceUsed}
          onChange={(e) => onFormDataChange({ serviceUsed: e.target.value })}
          required
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="serviceOutcome">Service Outcome</Label>
        <Textarea
          id="serviceOutcome"
          placeholder="What was the outcome of the service?"
          value={formData.serviceOutcome}
          onChange={(e) => onFormDataChange({ serviceOutcome: e.target.value })}
          required
        />
      </div>
    </div>
  );
};
